import React from "react";
import { User, EnvelopeSimple, CreditCard, QrCode, LockSimple, Spinner, Lightning } from "@phosphor-icons/react";
import { brl } from "@/lib/api";

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

const Method = ({ kind, active, onClick, icon: Icon, title, sub, testid }) => (
  <button type="button" onClick={onClick} data-active={active} data-kind={kind} className="vb-method" data-testid={testid}>
    <span className={`w-10 h-10 shrink-0 rounded-xl flex items-center justify-center ${kind === "pix" ? "bg-emerald-500/15 text-emerald-400" : "bg-indigo-500/15 text-indigo-300"}`}>
      <Icon size={22} weight="duotone" />
    </span>
    <span className="min-w-0">
      <span className="block font-display font-bold text-[15px] leading-tight">{title}</span>
      <span className="block text-[11px] text-slate-400 mt-0.5 leading-tight">{sub}</span>
    </span>
    <span className={`ml-auto w-4 h-4 shrink-0 rounded-full border-2 ${active ? "border-[#FFB30F] bg-[#FFB30F] shadow-[inset_0_0_0_3px_#121824]" : "border-white/25"}`} />
  </button>
);

export const CheckoutForm = ({ form, setForm, method, setMethod, acceptPix, acceptCard, price, loading, onSubmit }) => {
  const nameOk = form.name.trim().length >= 2;
  const emailOk = EMAIL_RE.test(form.email.trim());
  return (
    <form onSubmit={onSubmit} className="space-y-4" data-testid="checkout-form">
      <div className="relative">
        <User size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
        <input
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          placeholder="Seu nome completo"
          autoComplete="name"
          className={`vb-field ${nameOk ? "vb-ok" : ""}`}
          data-testid="checkout-input-name"
        />
      </div>
      <div className="relative">
        <EnvelopeSimple size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
        <input
          type="email"
          inputMode="email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          placeholder="Seu melhor e-mail"
          autoComplete="email"
          className={`vb-field ${emailOk ? "vb-ok" : ""}`}
          data-testid="checkout-input-email"
        />
      </div>

      <div>
        <div className="text-[11px] uppercase tracking-wider text-slate-400 mb-2">Forma de pagamento</div>
        <div className={`grid gap-2.5 ${acceptPix && acceptCard ? "grid-cols-1 min-[420px]:grid-cols-2" : "grid-cols-1"}`}>
          {acceptPix && (
            <Method kind="pix" active={method === "pix"} onClick={() => setMethod("pix")} icon={QrCode} title="Pix" sub="Aprovação imediata" testid="checkout-select-pix" />
          )}
          {acceptCard && (
            <Method kind="card" active={method === "card"} onClick={() => setMethod("card")} icon={CreditCard} title="Cartão" sub="Crédito · Visa, Master e mais" testid="checkout-select-card" />
          )}
        </div>
      </div>

      <button type="submit" disabled={loading || !nameOk || !emailOk} className={`vb-cta ${method === "pix" ? "vb-cta-green" : ""}`} data-testid="checkout-submit-btn">
        {loading ? <Spinner size={20} className="animate-spin" /> : <Lightning size={20} weight="fill" />}
        {method === "pix" ? `Gerar Pix de ${brl(price)}` : `Pagar ${brl(price)} com cartão`}
      </button>

      <div className="flex items-center justify-center gap-1.5 text-[11px] text-slate-500 text-center">
        <LockSimple size={12} />
        {method === "pix" ? "Pix processado com segurança pelo Mercado Pago" : "Cartão processado com segurança pela Stripe"}
      </div>
    </form>
  );
};
